import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
var ProfilePasswordComponent = (function () {
    function ProfilePasswordComponent(apiService, router) {
        this.apiService = apiService;
        this.router = router;
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.errorMessage = null;
    }
    ProfilePasswordComponent.prototype.submit = function () {
        var _this = this;
        this.sniff('CHANGE_PASSWORD', '');
        this.errorMessage = null;
        if (this.newPassword.length == 0)
            this.errorMessage = "โปรดกรอกรหัสผ่าน";
        else if (this.confirmPassword !== this.newPassword)
            this.errorMessage = "รหัสผ่านไม่ตรงกัน";
        else {
            this.apiService.updatePassword({
                old_password: this.oldPassword,
                new_password: this.newPassword
            }).subscribe(function () { return _this.router.navigate(['']); }, function (error) {
                var message = _this.apiService.getErrorMessage(error);
                _this.errorMessage = message;
            });
        }
    };
    ProfilePasswordComponent.prototype.sniff = function (action, detail) {
        var data = {
            action: action,
            feature: 'MANAGE_USER',
            detail: detail
        };
        this.apiService.sniff(data).subscribe();
    };
    return ProfilePasswordComponent;
}());
export { ProfilePasswordComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.ts.pre-build-optimizer.js